import React, { useEffect, useState } from "react";
import BreadCrumb from "../../layout/BreadCrumb";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../features/fetch/fetchSlice";
import CardLoading from "../../components/CardLoading";
import Search from "../../components/Search";
import { Table } from "antd";
import useModalToggle from "../../custom_hooks/useModalToggle";
import SetupView from "./SetupView";

function SetupList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const url = "api/v1/pages/list";
  const urlView = "api/v1/pages/properties";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
  const { user } = useSelector((state) => state.auth);
  const { saving } = useSelector((state) => state.save);
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState("");
  const { open, handleCancel, handleOpen } = useModalToggle();

  const [pageIndexView, setPageIndexView] = useState(0);
  const [pageSizeView, setPageSizeView] = useState(10);

  const handleShowDrawer = async (item) => {
    await setProdd(item);
    await handleFetchView(pageIndexView, pageSizeView, item?.pId);
    await handleOpen();
  };

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        pName: e.target.value == "" ? null : e.target.value,
        start:0,
        limit:null
      })
    );
  };

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      key: "index",
      render: (_, __, index) => index + 1,
      width: "3%",
    },
    {
      title: "Name",
      render: (item) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => handleShowDrawer(item)}
          >
            {item?.pName}
          </div>
        );
      },
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  async function handleFetchView(page, size, pId) {
    await dispatch(
      fetchData({
        url: urlView,
        pageId: pId,
        limit: size ?? pageSizeView,
        start: page ?? pageIndexView,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);

  if (loading && !searchInput && !open) return <CardLoading />;
  return (
    <>
      <BreadCrumb breadcrumbs={[{ title: "Gl Setups" }]} />

      <div className="white_card mt-[1.5rem] flex-1 min-h-[80vh]">
        <div className="flex items-center justify-between">
          <div className="lg:w-[29.1875rem] w-auto mt-[1.25rem]">
            <Search
              searchInput={searchInput}
              handleSearch={handleSearch}
              text={"Search ..."}
            />
          </div>
        </div>

        <Table
          rowSelection={false}
          className="mt-[2.25rem] w-full gl-account "
          scroll={{
            x: "auto",
          }}
          rowKey={(record) => record?.pId}
          columns={columns}
          dataSource={data}
          loading={loading}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: count,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
              fetchTableData(page - 1, size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
        />
      </div>

      <SetupView
        onClose={handleCancel}
        open={open}
        prodd={prodd}
        pageIndex={pageIndexView}
        setPageIndex={setPageIndexView}
        pageSize={pageSizeView}
        setPageSize={setPageSizeView}
        handleFetch={handleFetchView}
      />
    </>
  );
}

export default SetupList;
